import * as Sentry from "@sentry/react";

const dsn = import.meta.env.VITE_SENTRY_DSN;
const shouldSendFromLocal = import.meta.env.VITE_SENTRY_ENABLED === "true";
const release = import.meta.env.VITE_SENTRY_RELEASE?.trim() || undefined;
const feedbackEnabled = import.meta.env.VITE_SENTRY_FEEDBACK_ENABLED !== "false";
const feedbackScreenshotEnabled = import.meta.env.VITE_SENTRY_FEEDBACK_SCREENSHOT_ENABLED !== "false";
const feedbackShowBranding = import.meta.env.VITE_SENTRY_FEEDBACK_SHOW_BRANDING === "true";
const SUPABASE_URL_PATTERN = /^https?:\/\/(?:[^/]+\.)*supabase\.co(?:\/|$)/i;
const FACTORY_PILOT_API_URL_PATTERN = /^https?:\/\/api\.factory-pilot\.ai(?:\/|$)/i;

const toSampleRate = (value: string | undefined, fallback: number): number => {
  const parsed = Number(value);

  if (!Number.isFinite(parsed) || parsed < 0 || parsed > 1) {
    return fallback;
  }

  return parsed;
};

if (dsn && (import.meta.env.PROD || shouldSendFromLocal)) {
  const tracesSampleRate = toSampleRate(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE, 0.2);
  const replayEnabled = import.meta.env.VITE_SENTRY_REPLAY_ENABLED !== "false";
  const replayNetworkPayloadsEnabled = import.meta.env.VITE_SENTRY_REPLAY_NETWORK_PAYLOADS_ENABLED !== "false";
  const replaysSessionSampleRate = replayEnabled
    ? toSampleRate(import.meta.env.VITE_SENTRY_REPLAY_SESSION_SAMPLE_RATE, 0)
    : 0;
  const replaysOnErrorSampleRate = replayEnabled
    ? toSampleRate(import.meta.env.VITE_SENTRY_REPLAY_ON_ERROR_SAMPLE_RATE, 1)
    : 0;

  Sentry.init({
    dsn,
    release,
    environment: import.meta.env.MODE,
    enabled: true,
    tracesSampleRate,
    debug: import.meta.env.VITE_SENTRY_DEBUG === "true",
    replaysSessionSampleRate,
    replaysOnErrorSampleRate,
    integrations: [
      ...(replayEnabled
        ? [
            Sentry.replayIntegration({
              maskAllText: import.meta.env.VITE_SENTRY_REPLAY_MASK_ALL_TEXT !== "false",
              blockAllMedia: import.meta.env.VITE_SENTRY_REPLAY_BLOCK_ALL_MEDIA !== "false",
              maskAllInputs: import.meta.env.VITE_SENTRY_REPLAY_MASK_ALL_INPUTS !== "false",
              networkDetailAllowUrls: replayNetworkPayloadsEnabled
                ? [FACTORY_PILOT_API_URL_PATTERN, SUPABASE_URL_PATTERN]
                : [],
              networkCaptureBodies: replayNetworkPayloadsEnabled,
            }),
          ]
        : []),
      ...(feedbackEnabled
        ? [
            Sentry.feedbackIntegration({
              autoInject: false,
              id: "qc-sentry-feedback",
              showBranding: feedbackShowBranding,
              enableScreenshot: feedbackScreenshotEnabled,
              useSentryUser: {
                name: "username",
                email: "email",
              },
              tags: {
                feedback_source: "floating_button",
              },
            }),
          ]
        : []),
    ],
  });
}
